
import { mapGetters } from 'vuex'
import ProductDescriptionAccordionItem from '~/components/accordion-block/ProductDescriptionAccordionItem.vue'
import TechnicalFeaturesAccordion from '~/components/technical-features/TechnicalFeaturesAccordion'

export default {
  name: 'ProductDescription',
  components: {
    ProductDescriptionAccordionItem,
    TechnicalFeaturesAccordion
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    washingInstructions: {
      type: Array,
      default: () => [],
    },
    washingInstructionsBlock: {
      type: Object,
      default: () => ({}),
    },
    heading: {
      type: String,
      required: false,
      default: ''
    },
  },
  data () {
    return {
      truncated: true,
      groupId: this._uid,
      currentTab: 'details',
    }
  },
  computed: {
    ...mapGetters({
      generalSettings: 'storyblok/settings',
      getGbFeatureValue: 'growthbook/getGbFeatureValue',
    }),
    technicalFeaturesAccordionBlockContainer () {
      return this.generalSettings?.technicalFeaturesAccordionBlockContainer
    },
    accordionItems () {
      return [
        {
          title: this.$t('Product_Details_Description'),
          content: {
            html: `
              ${this.product.description}

              <strong>${this.$t('Product_Details_Sku')}</strong>: ${this.product.sku}
            `,
            videoUrl: this.product?.videoUrl || '',
            videoPoster: this?.videoPoster || {},
          }
        },
        {
          title: this.$t('Product_Details_Fabric_And_Care'),
          content: {
            html: `
              <strong>${this.$t('Product_Details_Washing_Advice')}</strong>: ${this.product.washingAdvice}
              <strong>${this.$t('Product_Details_Hook_And_Eye')}</strong>: ${this.product.hook}
              <strong>${this.$t('Product_Details_Material')}</strong>: ${this.product.material}
            `,
          }
        },
      ]
    },
    productHighlights () {
      const highlightArray = this.product?.productHighlight?.split(';')
      return highlightArray?.filter?.(Boolean)?.map(highlight => highlight.trim())
    },
    GBTechnicalFeatureAccordion () {
      return this.getGbFeatureValue('pdp:technical-features-accordion')
    },
    videoPoster () {
      return {
        filename: this.product?.videoImageUrl,
        alt: this.product?.name
      }
    },
  },
  methods: {
    openWashingInstructions () {
      this.$store.dispatch('ui/showWashingInstructions')
    },
    toggleNavbar (navbar) {
      this.currentTab = navbar
    },
  }
}
